import { useRef, useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function usePrevious(value: any): any {
	const ref = useRef();

	useEffect(() => {
		ref.current = value;
	}, [value]);

	return ref.current;
}

export default usePrevious;
